import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
import Table from "../../components/utils/Table";
import genericActions from "../../redux/generic/actions";
import { useDispatch, useSelector } from "react-redux";
import ActivationActions from "../../redux/activation/actions";

const { getPlan, getBillingCode } = genericActions;
const { createBulkActivation, resetMessage } = ActivationActions;



const MAX_RECORDS = 5000;

const BulkActivation = () => {
  const dispatch = useDispatch();
  const [previewData, setPreviewData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const billingCode = localStorage.getItem("BillingCode") || "12345";
  const [vailidError, setVailidError] = useState("");
  const [previewColumn, setPreviewColumn] = useState([]);
  const [totalUpload, setTotalUpload] = useState(0);
  const [vailidData, setVailidData] = useState(0);
  const [isvailidFlag, setIsvailidFlag] = useState(false);
  const [fileName, setFileName] = useState("");
  const { planList, getPlanLoading, billingCodeList } = useSelector((state) => state.generic);
  const { bulkActivationFResponse, bulkActivationLoading, bulkActivationMessage, bulkActivationError } = useSelector((state) => state.activation);


  const { register, handleSubmit, reset, setValue, watch, formState: { errors }, } = useForm({
    mode: "onChange",
    defaultValues: {
      planId: "",
      billingCode: ''
    },
  });

  useEffect(() => {
    dispatch(getPlan({ ActionType: 1, Month: 1 }))
    dispatch(getBillingCode({ ActionType: 1 }))

    return () => {
      dispatch(resetMessage());
    };
  }, [])

  const downloadResponseFile = () => {
    const data = [
      {
        "SerialNumber": '1234567890123456789',
        "ZipCode": '123456',
        "Street1": 'New York',
        "Street2": 'St2',
        'City': 'Test City',
        'State': 'Test State'
      }
    ];

    downloadExcelSampleFile(data, "bulk-activation-sample-file.xlsx");
  }

  const onFileUpload = (e) => {
    const fileReader = new FileReader();
    let file = e.target.files[0];

    setVailidError("");
    setIsvailidFlag(false);
    setPreviewColumn([]);
    setPreviewData([]);
    setTotalUpload(0);
    setVailidData(0);

    if (!file) return;

    // Validate file type
    if (!file.name.match(/\.(xlsx|xls)$/i)) {
      setVailidError("Please upload a valid file (.xlsx, .xls)");
      return;
    }

    setFileName(file.name);
    fileReader.readAsArrayBuffer(file);

    fileReader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Get first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert to JSON (rows)
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        defval: "", // avoid undefined
      });

      // Get columns (headers)
      const headers = Object.keys(jsonData[0] || {});
      const requiredColumns = ["SerialNumber", "ZipCode", "Street1", "Street2", 'City', 'State'];

      const isValid =
        headers.length === 6 && requiredColumns.every((col) => headers.includes(col));

      if (!isValid) {
        setVailidError("Invalid file. Required columns are missing or incorrect.",);
        return;
      }

      if (jsonData?.length > MAX_RECORDS) {
        setVailidError("Maximum 100 records allowed.",);
        return;
      }

      const heading = [
        ...headers.map((id) => ({ displayName: `${id}`, key: `${id}` })),
        { displayName: "Remarks", key: "remark" },
        { displayName: "Status", key: "status", textAlign: true },
      ];
      console.log("jsonData==>>", jsonData)
      setPreviewColumn(heading);
      const validatedData = validateData(jsonData) || [];
      console.log("validatedData==>>", validatedData)

      setPreviewData(validatedData);
      setTotalUpload(validatedData?.length);
    };
  };

  const validateData = (rows) => {
    const serialSeen = new Set();

    return rows.map((row) => {
      let remark = [];
      let validFlag = 1;

      const serial = String(row['SerialNumber'] || "").trim();

      // SerialNumber checks
      if (!serial) {
        remark.push("Serial number is missing");
        validFlag = 0;
      } else if (!/^\d+$/.test(serial)) {
        remark.push("Serial number must be numeric");
        validFlag = 0;
      } else if (serial.length !== 19) {
        remark.push("Serial number must be 19 digits");
        validFlag = 0;
      } else if (serialSeen.has(serial)) {
        remark.push("Duplicate serial number");
        validFlag = 0;
      } else {
        serialSeen.add(serial);
      }


      return {
        ...row,
        SerialNumber: serial,
        validFlag,
        remark: remark.length ? remark.join(", ") : "Valid",
      };
    });
  };

  const rowData = useMemo(() => {
    if (previewData && previewData.length > 0) {
      return previewData.map((item) => ({
        ...item,
        status:
          item.validFlag === 1 ? (
            <div className='text-success d-flex align-items-center justify-content-center'>
              <i className="ri-checkbox-circle-fill fs-6"></i> <span className="fw-semibold">Valid</span>
            </div>
          ) : (
            <div className="text-danger d-flex align-items-center justify-content-center">
              <i className="ri-close-circle-fill fs-6"></i><span className="fw-semibold">Invalid</span>
            </div>
          ),
      }));
    }
    return [];
  }, [previewData]);

  const onSubmit = (data) => {
    const simDetails = rowData && rowData.length > 0 && rowData.map((item) => {
      return {
        "iccid": item?.SerialNumber,
        "zipcode": item?.ZipCode,
        "street1": item?.Street1,
        "street2": item?.Street2 || '',
        "city": item?.City,
        "state": item?.State
      };
    });

    const payload = {
      ...data,
      "planId": Number(data?.planId) || 0,
      requestType: 2,
      sims: simDetails
    }
    console.log("payload :", payload);

    // dispatch(createBulkActivation(payload))
  };

  const handleReset = () => {
    reset();
    setSelectedFile(null);
    setVailidError("");
    setIsvailidFlag(false);
    setPreviewColumn([]);
    setPreviewData([]);
    setTotalUpload(0);
    setVailidData(0);
  };

  return (
    <CardLayout title=" Bulk Activation" icon="ri-flashlight-line fs-5"
      rightContent={<Button
        title="Sample File"
        buttonType="button"
        icon={<i className="ri-download-cloud-line me-1" />}
        variant="secondary"
        style={{
          padding: "4px 10px",
        }}
        onClick={downloadResponseFile}
      />}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          {/* Plan */}
          <div className="col-lg-3 col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Plan <span className="text-danger">*</span>
            </label>

            <select
              className="form-select"
              {...register("planId", {
                required: "Plan is required",
              })}
            >
              <option value="">Select Plan</option>
              {planList?.map((item) => (
                <option key={item?.PlanID} value={item?.PlanID}>
                  {item?.PlanName}
                </option>
              ))}
            </select>

            {errors.planId && <small className="text-danger">{errors.planId.message}</small>}
          </div>

          {/* Billing Code */}
          <div className="col-lg-3 col-md-6 mb-3">
            <label className="form-label fw-semibold">Billing Code <span className="text-danger">*</span></label>
            <select
              className="form-select"
              {...register("billingCode", {
                required: "Billing code is required",
              })}
            >
              <option value="">Select Billing Code</option>
              {billingCodeList && billingCodeList.length > 0 && billingCodeList.map((item) => (
                <option key={item?.BillingCode} value={item?.BillingCode}>
                  {item?.BillingCode}
                </option>
              ))}
            </select>
            {errors.billingCode && <small className="text-danger">{errors.billingCode.message}</small>}
          </div>

          <div className="form-group col-lg-3 col-md-4">
            <label className="form-label fw-semibold">
              Upload File <span className="text-danger">*</span>
            </label>
            {/* Hidden File Input */}
            <input
              type="file"
              accept=".xlsx,.xls"
              className="form-control"
              id="fileUpload"
              onChange={onFileUpload}
            />
            {vailidError && (<div className="" style={{ color: "#dc3545", fontSize: "12px", marginTop: "2px", }} > {vailidError} </div>)}
          </div>

          {/* Actions */}
          <div className="col-md-2 d-flex align-items-end" style={{ height: '70px' }}>
            <div className="d-flex gap-3">
              <Button
                title="Submit"
                buttonType="submit"
                variant="primary"
                loading={bulkActivationLoading}
                icon={<i className="ri-send-plane-fill me-2"></i>}
              />
              <Button
                title="Reset"
                buttonType="button"
                variant="secondary"
                disable={bulkActivationLoading}
                icon={<i className="ri-refresh-line me-2"></i>}
                onClick={handleReset}
              />
            </div>
          </div>
        </div>
      </form>

      {rowData && rowData.length > 0 && (<div className="mt-3">
        <Table
          columns={previewColumn}
          loading={false}
          data={rowData}
          pagination={true}
          tableHeight="200px"
        />
      </div>)}
    </CardLayout>
  );
};

export default BulkActivation;
